import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import WebsiteDetail from "@/pages/WebsiteDetail";
import KeywordDetail from "@/pages/KeywordDetail";
import PublicReport from "@/pages/PublicReport";
import { Toaster } from "@/components/ui/sonner";

function ProtectedLayout() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--rt-bg)]">
        <span className="label-eyebrow">Loading…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout />;
}

function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback synchronously - hash contains session_id
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/r/:token" element={<PublicReport />} />
      <Route element={<ProtectedLayout />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/websites/:id" element={<WebsiteDetail />} />
        <Route path="/keywords/:id" element={<KeywordDetail />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster
          position="top-right"
          toastOptions={{
            className: "rounded-none border border-[var(--rt-border)]",
            style: { borderRadius: 0 },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}
